export default __webpack_public_path__ + "static/media/Declaration of Independence_03.2c6eb547.jpg";